(() => {
  const historyKey = 'mishop:recommendation-history:v2';
  const legacySearchKey = 'mishop:last-search';
  const legacyProductKey = 'mishop:last-product';
  const ttlMs = 30 * 24 * 60 * 60 * 1000;
  const rootUrl = window.Shopify?.routes?.root || '/';

  function escapeHtml(value) {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function readRecommendationTerm() {
    try {
      const history = JSON.parse(window.localStorage.getItem(historyKey) || '{}');
      const cutoff = Date.now() - ttlMs;
      const recentSearch = Array.isArray(history.searches) ? history.searches.find((item) => item?.term && item.at >= cutoff) : null;
      if (recentSearch) return recentSearch.term;
      const recentProduct = Array.isArray(history.products) ? history.products.find((item) => item?.title && item.at >= cutoff) : null;
      if (recentProduct) return recentProduct.title;
      return (window.localStorage.getItem(legacySearchKey) || window.localStorage.getItem(legacyProductKey) || '').trim();
    } catch (_error) {
      return '';
    }
  }

  function parseJson(section, selector, fallback) {
    try {
      return JSON.parse(section.querySelector(selector)?.textContent || '');
    } catch (_error) {
      return fallback;
    }
  }

  function cardMarkup(product, labels) {
    const onSale = Number(product.compare_at_price_cents) > Number(product.price_cents);
    const image = product.image
      ? `<img class="mishop-personalized__image" src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy" width="600" height="600">`
      : `<span class="mishop-personalized__placeholder">${escapeHtml(labels.noImage)}</span>`;
    const action = product.requires_options
      ? `<a class="mishop-personalized__add mishop-personalized__add--options" href="${escapeHtml(product.url)}">${escapeHtml(labels.chooseOptions || 'Ver opciones')}</a>`
      : `<button class="mishop-personalized__add" type="button" data-variant-id="${escapeHtml(product.variant_id)}" ${product.available ? '' : 'disabled'}>${escapeHtml(product.available ? labels.add : labels.soldOut)}</button>`;

    return `
      <article class="mishop-personalized__card">
        <a class="mishop-personalized__image-link" href="${escapeHtml(product.url)}">${image}</a>
        <div class="mishop-personalized__content">
          <p class="mishop-personalized__vendor" title="${escapeHtml(product.vendor)}">${escapeHtml(product.vendor)}</p>
          <a class="mishop-personalized__name" href="${escapeHtml(product.url)}" title="${escapeHtml(product.title)}">${escapeHtml(product.title)}</a>
          <div class="mishop-personalized__prices">
            ${onSale ? `<span class="mishop-personalized__compare">${escapeHtml(product.compare_at_price)}</span>` : ''}
            <span class="mishop-personalized__price${onSale ? ' mishop-personalized__price--sale' : ''}">${escapeHtml(product.price)}</span>
          </div>
          ${action}
        </div>
      </article>`;
  }

  function syncCartBadges(cart) {
    const maxLabel = window.cartStrings?.item_99 || '99+';
    const countValue = cart.item_count < 100 ? String(cart.item_count) : maxLabel;
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = node.closest('.cart-text') ? `(${countValue})` : countValue;
    });
    document.querySelectorAll('.mishop-sticky-cart-count').forEach((node) => { node.textContent = countValue; });
    document.querySelectorAll('[data-cart-text]').forEach((node) => {
      const template = cart.item_count === 1 ? window.cartStrings?.item : window.cartStrings?.items;
      if (template) node.textContent = template.replace('[count]', cart.item_count);
    });
    window.updateCartEmptyStateVisibility?.(cart.item_count);
  }

  async function refreshCartUi(addResult) {
    const response = await fetch(`${rootUrl}cart.js`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error(`Cart refresh failed: HTTP ${response.status}`);
    const cart = await response.json();
    const cartState = { ...addResult, item_count: cart.item_count };
    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer && addResult?.sections && typeof cartDrawer.renderContents === 'function') {
      await cartDrawer.renderContents(cartState);
    }
    syncCartBadges(cart);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'mishop-personalized',
        productVariantId: addResult?.items?.[0]?.variant_id,
        cartData: cartState
      });
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    return cart;
  }

  async function addToCart(button, labels) {
    if (button.disabled || !button.dataset.variantId) return;
    const original = button.textContent;
    button.disabled = true;
    button.textContent = labels.adding;

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer?.getSectionsToRender?.().map((section) => section.id) || ['cart-drawer', 'cart-icon-bubble'];
      const response = await fetch(window.routes?.cart_add_url || `${rootUrl}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections,
          sections_url: window.location.pathname
        })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || labels.error);
      await refreshCartUi(result);
      button.textContent = labels.added;
      window.setTimeout(() => {
        button.textContent = original;
        button.disabled = false;
      }, 1400);
    } catch (error) {
      console.error('[MISHOP personalized] Add to cart failed', error);
      button.textContent = labels.retry;
      button.disabled = false;
    }
  }

  function renderProducts(section, products, labels) {
    const grid = section.querySelector('[data-personalized-grid]');
    const status = section.querySelector('[data-personalized-status]');
    if (!products.length) {
      status.textContent = labels.empty || 'No encontramos productos relacionados.';
      return;
    }
    grid.innerHTML = products.map((product) => cardMarkup(product, labels)).join('');
    status.hidden = true;
    grid.hidden = false;
  }

  async function renderSection(section) {
    if (section.dataset.loaded === 'true') return;
    section.dataset.loaded = 'true';
    const limit = Math.min(Number(section.dataset.limit) || 12, 12);
    const labels = parseJson(section, '[data-personalized-labels]', {});
    const defaults = parseJson(section, '[data-personalized-default-products]', { products: [] });
    const term = readRecommendationTerm();
    const fallback = (section.dataset.fallbackSearch || '').trim();
    const query = term || fallback;
    const subtitle = section.querySelector('[data-personalized-subtitle]');
    const status = section.querySelector('[data-personalized-status]');

    section.hidden = false;
    if (!query && Array.isArray(defaults.products) && defaults.products.length) {
      subtitle.hidden = true;
      renderProducts(section, defaults.products.slice(0, limit), labels);
      return;
    }
    if (!query) {
      section.hidden = true;
      return;
    }

    subtitle.hidden = false;
    subtitle.textContent = (labels.related || 'Productos relacionados con “{term}”').replace('{term}', query);
    status.textContent = labels.loading || 'Cargando recomendaciones…';

    try {
      const endpoint = `${rootUrl}search?q=${encodeURIComponent(query)}&type=product&view=mishop-personalized`;
      const response = await fetch(endpoint, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const payload = await response.json();
      renderProducts(section, Array.isArray(payload.products) ? payload.products.slice(0, limit) : [], labels);
    } catch (error) {
      console.error('[MISHOP personalized] Recommendations failed', error);
      status.textContent = labels.error || 'No fue posible cargar las recomendaciones.';
    }
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-mishop-personalized]').forEach((section) => {
      renderSection(section);
      if (section.dataset.clickBound === 'true') return;
      section.dataset.clickBound = 'true';
      section.addEventListener('click', (event) => {
        const button = event.target.closest('.mishop-personalized__add[data-variant-id]');
        if (button) addToCart(button, parseJson(section, '[data-personalized-labels]', {}));
      });
    });
  }

  const start = () => {
    if ('requestIdleCallback' in window) window.requestIdleCallback(() => init(), { timeout: 1200 });
    else window.setTimeout(() => init(), 300);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
